import Joi from 'joi'

const notificationValidationSchema = Joi.object({
  isEmailNotification: Joi.boolean().required(),
  isEmailNotificationForNewAvailableBookings: Joi.boolean().required(),
  isMobileAppNotification: Joi.boolean().required(),
  isMobileNotificationForNewAvailableBookings: Joi.boolean().required(),
  isMobileNotificationForHgvJobs: Joi.boolean().required(),
  isMobileNotificationForNonHgvJobs: Joi.boolean().required(),
  notificationRadiusKm: Joi.string()
    .trim()
    .pattern(/^\d+$/)
    .custom((value, helpers) => {
      const radius = Number(value)
      if (radius < 20 || radius > 500) {
        return helpers.error('number.range')
      }
      return value
    })
    .messages({
      'string.empty': 'Enter a value between 20 and 500 km',
      'string.pattern.base': 'Enter a whole number between 20 and 500 km',
      'number.range': 'Enter a value between 20 and 500 km',
    })
    .required(),
})

export default notificationValidationSchema
